import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import DataTable from "react-data-table-component";
import { Modal, Button } from "react-bootstrap";

function ListaPrecios() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus,setModalContainerStatus] = useState('');
    const [modalBackdropStatus,setModalBackdropStatus] = useState('zindex-back');
    let userdata = [];
    let clientData = [];

    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [clasificacionFiltro, setClasificacionFiltro] = useState('');
    const [especialidades, setEspecialidades] = useState([]);

    const [toastMsg, setToastMsg] = useState('');

    // Estados para modal de ajuste masivo
    const [modalAjusteMasivoStatus, setModalAjusteMasivoStatus] = useState('');
    const [clasificacionAjuste, setClasificacionAjuste] = useState('');
    const [tipoAjuste, setTipoAjuste] = useState('aumentar');
    const [porcentajeAjuste, setPorcentajeAjuste] = useState('');
    const [itemsAfectados, setItemsAfectados] = useState(0);
    const [loadingAjuste, setLoadingAjuste] = useState(false);

    // Estados para modal de confirmación del ajuste
    const [showModalConfirmacionAjuste, setShowModalConfirmacionAjuste] = useState(false);
    const [mensajeConfirmacion, setMensajeConfirmacion] = useState('');
    
    // Estados para modal de éxito
    const [showModalExito, setShowModalExito] = useState(false);
    const [mensajeExito, setMensajeExito] = useState('');

    let pesos = Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
    });

    const cols = [
        { name:'Código', selector:row => row.codigo, sortable:true, width: '10%' },
        { name:'CUPS', selector:row => row.codigorips || '', sortable:true, width: '12%' },
        {
            name:'Nombre',
            selector:row => row.nombre,
            sortable:true,
            width: '40%',
            cell: row => {
                const nombre = row.nombre != null ? String(row.nombre) : '';
                return (
                    <span className="lista-precios-nombre-wrap" data-tip={nombre || undefined}>
                        <span className="lista-precios-nombre">{nombre || '—'}</span>
                    </span>
                );
            },
        },
        {
            name:'Clasificación',
            selector:row => row.clasificacion,
            sortable:true,
            width: '14%',
            center: true,
        },
        { name:'Valor', selector:row => pesos.format(row.precio), sortable:true, width: '12%' },
        { name:'Acción', cell:row => getBotones(row), width: '12%', center: true }
    ];

    const getBotones = (item) => {
        const puedeEliminar = Number(item.puede_eliminar) === 1;

        return (
            <div style={{display: 'flex', gap: '5px', flexWrap: 'nowrap', alignItems: 'center', justifyContent: 'center'}}>
                <button
                    type="button"
                    className={`btn btn-sm lista-precio-estado-btn ${Number(item.estado) === 1 ? 'is-off' : 'is-on'}`}
                    title={Number(item.estado) === 1 ? 'Inactivo — clic para activar' : 'Activo — clic para inactivar'}
                    onClick={() => toggleEstado(item)}
                >
                    <i className={`fas fa-lightbulb ${Number(item.estado) === 1 ? '' : 'text-warning'}`}></i>
                </button>
                <Link to={'/lista-precio?id='+item.id} className="btn btn-primary btn-sm" title="Editar">
                    <i className="far fa-edit"></i>
                </Link>
                {puedeEliminar ? (
                    <button
                        type="button"
                        className="btn btn-outline-danger btn-sm"
                        title="Eliminar ítem"
                        onClick={() => showModal(item.id)}
                    >
                        <i className="fas fa-trash-alt"></i>
                    </button>
                ) : (
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm"
                        disabled
                        title="No se puede eliminar: ya se usó en factura, presupuesto o RIPS. Usa el bombillo para inactivar."
                    >
                        <i className="fas fa-trash-alt"></i>
                    </button>
                )}
            </div>
        )
    }

    const toggleEstado = (item) => {
        const userdataLocal = JSON.parse(localStorage.getItem('userdata') || '{}');
        const nuevoEstado = Number(item.estado) === 1 ? 0 : 1;
        axios.put('/lista-precio-estado', { id: item.id, estado: nuevoEstado }, {
            headers: { Authorization: 'Bearer ' + userdataLocal.access_token }
        })
            .then((response) => {
                if (response.status === 200) {
                    setItems((prev) =>
                        prev.map((row) =>
                            String(row.id) === String(item.id)
                                ? { ...row, estado: response.data.estado }
                                : row
                        )
                    );
                    setToastMsg(response.data.message || (nuevoEstado === 0 ? 'Ítem activado' : 'Ítem inactivado'));
                }
            })
            .catch((error) => {
                alert(error.response?.data?.message || error.response?.data?.error || 'No se pudo cambiar el estado');
            });
    };

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }
        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });


        axios.get('/lista-precios?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setItems(response.data);
                    console.log(response.data);
                }
            })
            .catch(error => {
                
                console.log(JSON.stringify(error));
            });

        axios.get('/especialidades-referencia?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setEspecialidades(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
    },[]);

    const eliminar = (e) => {
        const userdataLocal = JSON.parse(localStorage.getItem('userdata') || '{}');
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdataLocal.access_token
            },
            params: {
                id: e
            }
        }
        
        axios.delete('/lista-precio?uid='+userdataLocal.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setItems([]);
                    let nuevoItems = items;
                    let nombreItem = "";

                    nuevoItems.map((item) => {
                        if (item.id==e) {
                            nombreItem = item.nombre;
                            const i = nuevoItems.indexOf(item);
                            if (i > -1) {
                                nuevoItems.splice(i, 1);
                            }
                        }
                    });

                    setItems(nuevoItems);
                    cerrar();

                    setToastMsg('El Item De Venta'+nombreItem+' Ha Sido Eliminado');
                }
            })
            .catch(error => {
                cerrar();
                const msg = error.response?.data?.message || error.response?.data?.error || 'No se pudo eliminar el ítem';
                alert(msg);
            });
    }

    const showModal = (e) => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
        setIdItemEliminar(e);
    }

    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        setIdItemEliminar(null);
    }

    const abrirModalAjusteMasivo = () => {
        setModalAjusteMasivoStatus('show');
        setModalBackdropStatus('show');
        // Reset form
        setClasificacionAjuste('');
        setTipoAjuste('aumentar');
        setPorcentajeAjuste('');
        setItemsAfectados(0);
    }

    const cerrarModalAjusteMasivo = () => {
        setModalAjusteMasivoStatus('');
        setModalBackdropStatus('zindex-back');
        setClasificacionAjuste('');
        setTipoAjuste('aumentar');
        setPorcentajeAjuste('');
        setItemsAfectados(0);
    }

    // Funciones para modal de confirmación
    const handleShowConfirmacionAjuste = () => setShowModalConfirmacionAjuste(true);
    const handleCloseConfirmacionAjuste = () => setShowModalConfirmacionAjuste(false);
    
    // Funciones para modal de éxito
    const handleShowModalExito = () => setShowModalExito(true);
    const handleCloseModalExito = () => {
        setShowModalExito(false);
        cerrarModalAjusteMasivo();
    };

    const calcularItemsAfectados = (clasificacionId) => {
        if (!clasificacionId) {
            setItemsAfectados(0);
            return;
        }
        
        // Si es "todas", contar todos los items
        if (clasificacionId === 'todas') {
            setItemsAfectados(items.length);
            return;
        }
        
        // Contar items en la clasificación seleccionada
        const clasificacionNombre = especialidades.find(e => e.id == clasificacionId)?.nombre;
        const count = items.filter(item => item.clasificacion === clasificacionNombre).length;
        
        setItemsAfectados(count);
    }

    const aplicarAjusteMasivo = () => {
        // Validaciones
        if (!clasificacionAjuste) {
            alert('Por favor seleccione una clasificación');
            return;
        }
        
        if (!porcentajeAjuste || parseFloat(porcentajeAjuste) <= 0) {
            alert('Por favor ingrese un porcentaje válido mayor a 0');
            return;
        }
        
        if (itemsAfectados === 0) {
            alert('No hay items en la clasificación seleccionada');
            return;
        }
        
        // Construir mensaje de confirmación
        const clasificacionNombre = clasificacionAjuste === 'todas' 
            ? 'TODAS LAS CLASIFICACIONES' 
            : especialidades.find(e => e.id == clasificacionAjuste)?.nombre;
        
        const mensaje = `Esta acción NO se puede revertir.\n\n` +
                       `Está a punto de aplicar los siguientes cambios:\n\n` +
                       `• Clasificación: ${clasificacionNombre}\n` +
                       `• Tipo: ${tipoAjuste === 'aumentar' ? 'Aumentar' : 'Disminuir'}\n` +
                       `• Porcentaje: ${porcentajeAjuste}%\n` +
                       `• Items afectados: ${itemsAfectados}\n\n` +
                       `¿Está seguro de continuar?`;
        
        setMensajeConfirmacion(mensaje);
        handleShowConfirmacionAjuste();
    }

    const handleConfirmarAjuste = () => {
        handleCloseConfirmacionAjuste();
        ejecutarAjusteMasivo();
    }

    const ejecutarAjusteMasivo = () => {
        setLoadingAjuste(true);
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }
        
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };
        
        const data = {
            clasificacion_id: clasificacionAjuste === 'todas' ? 'todas' : parseInt(clasificacionAjuste),
            tipo_ajuste: tipoAjuste,
            porcentaje: parseFloat(porcentajeAjuste)
        };
        
        axios.post('/lista-precios/ajuste-masivo', data, config)
            .then(response => {
                setLoadingAjuste(false);
                
                if (response.status === 200) {
                    const registrosActualizados = response.data.registros_actualizados;
                    setMensajeExito(`Ajuste aplicado exitosamente.\n${registrosActualizados} precios actualizados.`);
                    
                    // Recargar lista de precios
                    axios.get('/lista-precios?uid=' + userdata.user_id, config)
                        .then(response => {
                            if (response.status === 200) {
                                setItems(response.data);
                            }
                        })
                        .catch(error => {
                            console.log('Error recargando precios:', error);
                        });
                    
                    // Mostrar modal de éxito
                    setTimeout(() => { handleShowModalExito() }, 500);
                }
            })
            .catch(error => {
                setLoadingAjuste(false);
                console.log('Error aplicando ajuste:', error);
                
                const errorMsg = error.response?.data?.message || 
                               error.response?.data?.error || 
                               'Error al aplicar el ajuste masivo';
                alert('Error: ' + errorMsg);
            });
    }


    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                termino: terminoBusqueda,
                clasificacion: clasificacionFiltro
            }
        }

        axios.get('/lista-precios',config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error);
            })

    },[terminoBusqueda, clasificacionFiltro]);



    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-tratamientos">Administrador Contable</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Listas de Precios</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Listas de Precios</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            
                        <div className="row" style={{marginBottom: '30px'}}>
                            <div className="col-md-6">
                                <Link to="/nueva-lista-precios" className="btn btn-primary">Crear Nueva</Link>
                                <Link to="#" onClick={abrirModalAjusteMasivo} className="btn btn-primary" style={{marginLeft: '10px'}}>
                                    <i className="fas fa-percentage"></i> Ajustes General de Precios
                                </Link>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="clasificacionFiltro">Clasificación</label>
                                    <select name="clasificacionFiltro" id="clasificacionFiltro" className="form-control" onChange={(e)=> setClasificacionFiltro(e.target.value)}>
                                        <option value="">Todos</option>
                                        {especialidades.map((esp) => (
                                            <option key={esp.id} value={esp.id}>{esp.nombre}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="terminoBusqueda">Buscar</label>
                                    <input type="text" name="terminoBusqueda" className="form-control" id="terminoBusqueda" onChange={(e) => setTerminoBusqueda(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 lista-precios-table">
                                
                                <DataTable
                                columns={cols}
                                data={items}
                                pagination
                                paginationComponentOptions={{
                                    rowsPerPageText: 'Filas por página:',
                                    rangeSeparatorText: 'de',
                                    noRowsPerPage: false,
                                    selectAllRowsItem: true,
                                    selectAllRowsItemText: 'Todos'
                                }}
                                noDataComponent="No hay registros para mostrar"
                                id={'lista_precios'}
                                />

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>

                <div className={'modal-container modal fade in '+modalContainerStatus}>
                    <div className="modal-dialog">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h4 className="modal-title">Eliminar De Lista De Precios</h4>
                                <button type="button" className="close" onClick={() => cerrar()}>&times;</button>
                            </div>

                            <div className="modal-body">
                                ¿Esta Seguro Que Desea Eliminar La Opcion Seleccionada?
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => cerrar()}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={() => eliminar(idItemEliminar)}>Eliminar</button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={'modal-backdrop fade '+modalBackdropStatus}></div>

                {/* Modal de Ajuste Masivo */}
                <div className={'modal-container modal fade in ' + modalAjusteMasivoStatus}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Ajuste General de Precios</h4>
                                <button type="button" className="close" onClick={cerrarModalAjusteMasivo}>&times;</button>
                            </div>

                            <div className="modal-body">
                                <div className="form-group">
                                    <label htmlFor="clasificacionAjuste">Clasificación *</label>
                                    <select 
                                        name="clasificacionAjuste" 
                                        id="clasificacionAjuste" 
                                        className="form-control"
                                        value={clasificacionAjuste}
                                        onChange={(e) => {
                                            setClasificacionAjuste(e.target.value);
                                            calcularItemsAfectados(e.target.value);
                                        }}
                                        disabled={loadingAjuste}
                                    >
                                        <option value="">Seleccione una clasificación</option>
                                        <option value="todas">Todos</option>
                                        {especialidades.map((esp) => (
                                            <option key={esp.id} value={esp.id}>{esp.nombre}</option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group">
                                    <label>Tipo de Ajuste *</label>
                                    <div>
                                        <label style={{marginRight: '20px'}}>
                                            <input 
                                                type="radio" 
                                                name="tipoAjuste" 
                                                value="aumentar"
                                                checked={tipoAjuste === 'aumentar'}
                                                onChange={(e) => setTipoAjuste(e.target.value)}
                                                disabled={loadingAjuste}
                                            /> Aumentar
                                        </label>
                                        <label>
                                            <input 
                                                type="radio" 
                                                name="tipoAjuste" 
                                                value="disminuir"
                                                checked={tipoAjuste === 'disminuir'}
                                                onChange={(e) => setTipoAjuste(e.target.value)}
                                                disabled={loadingAjuste}
                                            /> Disminuir
                                        </label>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label htmlFor="porcentajeAjuste">Porcentaje (%) *</label>
                                    <input 
                                        type="number" 
                                        name="porcentajeAjuste" 
                                        id="porcentajeAjuste"
                                        className="form-control"
                                        placeholder="Ej: 5 para 5%"
                                        min="0.01"
                                        step="0.01"
                                        value={porcentajeAjuste}
                                        onChange={(e) => setPorcentajeAjuste(e.target.value)}
                                        disabled={loadingAjuste}
                                    />
                                    <small className="form-text text-muted">
                                        Los precios se redondearán automáticamente al entero más cercano
                                    </small>
                                </div>

                                {clasificacionAjuste && (
                                    <div className="alert alert-info">
                                        <i className="fas fa-info-circle"></i> {itemsAfectados} items serán afectados
                                    </div>
                                )}

                                <div className="alert alert ">
                                    <i className="fas fa-exclamation-triangle"></i> <strong>Advertencia:</strong> Luego de realizar esta Accion No se puede revertir.
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button 
                                    type="button" 
                                    className="btn btn-secondary" 
                                    onClick={cerrarModalAjusteMasivo}
                                    disabled={loadingAjuste}
                                >
                                    Cancelar
                                </button>
                                <button 
                                    type="button" 
                                    className="btn btn-primary" 
                                    onClick={aplicarAjusteMasivo}
                                    disabled={loadingAjuste}
                                >
                                    {loadingAjuste ? 'Aplicando...' : 'Aplicar Ajuste'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Modal de Confirmación del Ajuste */}
                <Modal show={showModalConfirmacionAjuste} onHide={handleCloseConfirmacionAjuste}>
                    <Modal.Header closeButton className="bg-warning">
                        <Modal.Title>
                            <i className="fas fa-exclamation-triangle"></i> Confirmar Ajuste Masivo
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {mensajeConfirmacion}
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseConfirmacionAjuste}>
                            Cancelar
                        </Button>
                        <Button variant="warning" onClick={handleConfirmarAjuste}>
                            Sí, Aplicar Ajuste
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de Éxito */}
                <Modal show={showModalExito} onHide={handleCloseModalExito}>
                    <Modal.Header closeButton className="bg-info">
                        <Modal.Title>
                            <i className="fas fa-check-circle"></i> Ajuste Completado
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {mensajeExito}
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="info" onClick={handleCloseModalExito}>
                            Aceptar
                        </Button>
                    </Modal.Footer>
                </Modal>

                <Footer showToast={false} delay={0} message={toastMsg} />
                <style>{`
                    .lista-precios-table .rdt_TableCell {
                        overflow: visible;
                    }
                    .lista-precios-nombre-wrap {
                        position: relative;
                        display: block;
                        max-width: 100%;
                        cursor: default;
                    }
                    .lista-precios-nombre {
                        display: block;
                        max-width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                    .lista-precios-nombre-wrap[data-tip]:hover::after {
                        content: attr(data-tip);
                        position: absolute;
                        left: 0;
                        bottom: calc(100% + 8px);
                        z-index: 30;
                        max-width: min(420px, 70vw);
                        padding: 8px 12px;
                        background: #2c3e50;
                        color: #fff;
                        font-size: 12px;
                        line-height: 1.35;
                        white-space: normal;
                        border-radius: 10px;
                        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
                        pointer-events: none;
                    }
                    .lista-precios-nombre-wrap[data-tip]:hover::before {
                        content: '';
                        position: absolute;
                        left: 14px;
                        bottom: calc(100% + 2px);
                        z-index: 31;
                        border: 6px solid transparent;
                        border-top-color: #2c3e50;
                        pointer-events: none;
                    }
                    .lista-precio-estado-btn {
                        width: 34px;
                        height: 34px;
                        border-radius: 50%;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        padding: 0;
                    }
                    .lista-precio-estado-btn.is-on {
                        background: rgba(255, 193, 7, 0.18);
                        border: 1px solid rgba(255, 193, 7, 0.45);
                        color: #d39e00;
                    }
                    .lista-precio-estado-btn.is-off {
                        background: rgba(108, 117, 125, 0.12);
                        border: 1px solid rgba(108, 117, 125, 0.28);
                        color: #adb5bd;
                    }
                    .lista-precio-estado-btn.is-off i {
                        opacity: 0.55;
                    }
                `}</style>
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default ListaPrecios;